const darkIcons = {
  21: require('./21.svg'),
  22: require('./22.svg'),
  23: require('./23.svg'),
  24: require('./24.svg'),
  25: require('./25.svg'),
  26: require('./26.svg'),
  27: require('./27.svg'),
  28: require('./28.svg'),
  29: require('./29.svg'),
  41: require('./29.svg'),
  40: require('./29.svg'),
  42: require('./42.svg'),
  64: require('./64.svg'),
};

export default darkIcons;

/*
24 "Co-mingle"
27 "Coffee Cups"
29 "Dry Waste"
26 "E-Waste"
21 "Landfill"
25 "Organics"
23 "Paper"
22 "Recycling"
28 "Soft Plastics"
41 "Your Choice"
64 "10C Refundables"
42 "Clinical Waste"
40 "Misc"
*/
